import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { routerShape } from '@bibliocommons/bc-prop-types';

import './SearchScopeField.scss';

export class SearchScopeField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getHrefForScope(searchScope) {
    const { router } = this.props;
    return router.createHref({
      query: {
        ...router.query,
        searchScope,
        lastSearchScope: router.query.searchScope
      }
    });
  }

  renderScopeLink(scope, index) {
    const linkClasses = classNames('filter', {
      applied: this.props.currentSearchScope === scope.get('scopeId')
    });

    const styles = {
      paddingLeft: `${index <= 1 ? 0 : index - 1}em`
    };

    return (
      <li className={linkClasses} style={styles} key={scope.get('scopeId')}>
        <a
          href={this.getHrefForScope(scope.get('scopeId'))}
          data-scope-id={scope.get('scopeId')}
          onClick={this.updateScope}
        >
          {index > 0 ? '\u2014 ' : ''}
          {scope.get('scopeName')}
        </a>
      </li>
    );
  }

  render() {
    return (
      <section className="cp-search-scope-field">
        <FormattedMessage id="section_title_show_results_at">
          {message => <h4 className="field-name">{message}</h4>}
        </FormattedMessage>
        <ul className="filter-list">{this.props.scopes.map(this.renderScopeLink)}</ul>
      </section>
    );
  }
}

SearchScopeField.displayName = 'SearchScopeField';
SearchScopeField.propTypes = {
  currentSearchScope: PropTypes.string.isRequired,
  router: routerShape,
  scopes: ImmutablePropTypes.list.isRequired
};

export default withRouter(SearchScopeField);
